//====================================================
//  Function: Accordion
//====================================================
function componentAccordion() {
  $(document).on('click', '.js-accordion-trigger', function () {
    var inst = $(this)
    var thisAccordionItem = inst.closest('.js-accordion-item')
    var accordionBlock = inst.closest('.js-accordion-group')

    if (thisAccordionItem.hasClass(classIsActive)) {
      thisAccordionItem.toggleClass(classIsActive)
    } else {
      accordionBlock
        .find('.js-accordion-item.' + classIsActive + '')
        .removeClass(classIsActive)
      inst.closest('.js-accordion-item').addClass(classIsActive)

      if (windowWidth > bpSmall) {
        var navigationHeight = 130
      } else {
        var navigationHeight = 60
      }

      $('html, body')
        .stop()
        .animate({
          scrollTop: thisAccordionItem.offset().top - navigationHeight,
        })
    }
    return false
  })
}
